var map = {
	"./basenji.png": 131,
	"./beagle.png": 474,
	"./big.png": 760,
	"./border.png": 392,
	"./king.png": 272,
	"./pastor.jpg": 234,
	"./pastorA.png": 312,
	"./pug.jpg": 467,
	"./roky.png": 502,
	"./rott.jpg": 722,
	"./saluki.jpg": 662,
	"./shepherd.png": 114,
	"./terrier.png": 958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;